/* SOLUM CLAVIS — agent de guidage « Call us » (toutes les pages Pro)
   ──────────────────────────────────────────────────────────────────
   Pendant un appel voix (hub = sc-pro-call.js sur le dashboard), cet agent
   donne à l'assistante des yeux et des mains sur CET onglet, via
   BroadcastChannel "scpc-guide" (même origine) :
   - hello/focus/bye → le hub sait quels onglets Solum sont ouverts ;
   - cmd read       → titre + headings + libellés des éléments cliquables ;
   - cmd highlight  → spotlight terracotta sur un élément trouvé par libellé,
                      clic réel remonté au hub ([ui-event] pour la voix) ;
   - cmd clear      → retire le spotlight.
   Chargé par snippets/sc-call.liquid (layouts theme + sc-v2), pros only.
   L'agent coexiste avec le hub sur chaque page : le hub gère SON onglet
   pendant SON appel ; l'agent répond aux ordres venus des AUTRES onglets
   (les messages portant son propre page id sont ignorés). */
(function () {
  "use strict";
  if (typeof BroadcastChannel === "undefined") return;

  var m = location.pathname.match(/\/pages\/([a-z0-9-]+)/);
  var PAGE = m ? m[1] : location.pathname.replace(/^\/+|\/+$/g, "").replace(/\//g, "-") || "home";
  var bc = new BroadcastChannel("scpc-guide");

  function post(o) { try { bc.postMessage(o); } catch (e) {} }
  function hello() { post({ t: "hello", page: PAGE, title: document.title, focused: document.hasFocus() }); }

  /* ── inventaire des éléments cliquables visibles ───────────────────── */
  function labelOf(el) {
    var v = el.getAttribute("aria-label") || el.value || el.placeholder || el.innerText || "";
    return String(v).replace(/\s+/g, " ").trim().slice(0, 80);
  }
  function isVisible(el) {
    if (el.offsetParent === null && getComputedStyle(el).position !== "fixed") return false;
    var r = el.getBoundingClientRect();
    return r.width > 8 && r.height > 8;
  }
  function scan() {
    var els = document.querySelectorAll('button, a[href], input:not([type="hidden"]), select, textarea, [role="button"], label[for]');
    var out = [], seen = {};
    for (var i = 0; i < els.length && out.length < 80; i++) {
      var el = els[i];
      if (!isVisible(el)) continue;
      var lb = labelOf(el);
      if (!lb || seen[lb]) continue;
      seen[lb] = el;
      out.push(lb);
    }
    return { labels: out, map: seen };
  }
  function headings() {
    var hs = document.querySelectorAll("h1,h2,h3");
    var out = [];
    for (var i = 0; i < hs.length && out.length < 12; i++) {
      var t = (hs[i].innerText || "").replace(/\s+/g, " ").trim().slice(0, 90);
      if (t && isVisible(hs[i])) out.push(t);
    }
    return out;
  }

  /* ── Le TEXTE de la page ────────────────────────────────────────────────
     Sans lui l'assistante « voit » une fiche produit sans pouvoir la lire :
     le prix, l'état, la matière, les dimensions, les notes d'état ne sont ni
     des titres ni des éléments cliquables (signalé par Marc le 2026-08-21 sur
     /pages/piece — elle connaissait le nom de la pièce et rien d'autre).
     Générique, aucun sélecteur par page : on parcourt le contenu principal
     bloc par bloc en sautant le chrome. innerText suit la mise en page réelle,
     donc ni les panneaux repliés ni l'autre langue ne remontent. */
  var PAGE_TEXT_MAX = 2200;
  function readBlocks(root, limit) {
    var SKIP_TAG = /^(SCRIPT|STYLE|NOSCRIPT|HEADER|FOOTER|NAV|TEMPLATE)$/;
    var SKIP_ID = /^(scpcOverlay|scpcSpot|scCallCfg|peuCartDrawer)$/;
    var SKIP_CLS = /scpc-band|po-cart-drawer|sc-call/;
    var kids = root.children && root.children.length ? root.children : [root];
    var out = [], n = 0;
    for (var i = 0; i < kids.length && n < limit; i++) {
      var el = kids[i];
      if (SKIP_TAG.test(el.tagName) || SKIP_ID.test(el.id || "")) continue;
      if (SKIP_CLS.test(String(el.className || ""))) continue;
      if (!isVisible(el)) continue;
      var t = (el.innerText || "").replace(/[ \t]+/g, " ").replace(/\n{2,}/g, "\n").trim();
      if (!t) continue;
      out.push(t); n += t.length;
    }
    return out.join("\n");
  }
  function pageText() {
    var m = document.querySelector("main, [role=main], #MainContent");
    var s = m ? readBlocks(m, PAGE_TEXT_MAX) : "";
    if (s.length < 40) s = readBlocks(document.body, PAGE_TEXT_MAX);
    return s.length > PAGE_TEXT_MAX ? s.slice(0, PAGE_TEXT_MAX) + " \u2026" : s;
  }

  function findByLabel(q) {
    var s = scan(), keys = Object.keys(s.map), ql = q.toLowerCase();
    for (var i = 0; i < keys.length; i++) if (keys[i].toLowerCase() === ql) return { el: s.map[keys[i]], label: keys[i] };
    for (i = 0; i < keys.length; i++) if (keys[i].toLowerCase().indexOf(ql) !== -1) return { el: s.map[keys[i]], label: keys[i] };
    for (i = 0; i < keys.length; i++) if (ql.indexOf(keys[i].toLowerCase()) !== -1 && keys[i].length > 3) return { el: s.map[keys[i]], label: keys[i] };
    return null;
  }

  /* ── spotlight (même dessin que le hub) ────────────────────────────── */
  var spotEl = null, spotTarget = null, spotRaf = 0, spotClickH = null;
  var spotStaleAt = 0, spotLabel = "";
  function injectCss() {
    if (document.getElementById("scpaCss")) return;
    var st = document.createElement("style");
    st.id = "scpaCss";
    st.textContent = "#scpaSpot{position:fixed;z-index:2147482550;pointer-events:none;border:2px solid #bf5b3f;border-color:oklch(58% .16 35);border-radius:16px;box-shadow:0 0 0 9999px rgba(30,24,18,.32),0 0 0 6px rgba(191,91,63,.22);animation:scpaPulse 1.8s ease-in-out infinite}@keyframes scpaPulse{0%,100%{box-shadow:0 0 0 9999px rgba(30,24,18,.32),0 0 0 4px rgba(191,91,63,.16)}50%{box-shadow:0 0 0 9999px rgba(30,24,18,.32),0 0 0 11px rgba(191,91,63,.32)}}.scpa-hint{position:absolute;right:-13px;bottom:-13px;display:flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:999px;background:#bf5b3f;background:oklch(58% .16 35);color:#fff;box-shadow:0 4px 12px rgba(30,24,18,.35);animation:scpaBob 1.4s ease-in-out infinite}@keyframes scpaBob{0%,100%{transform:translateY(0)}50%{transform:translateY(4px)}}";
    document.head.appendChild(st);
  }
  function positionSpot() {
    if (!spotTarget || !spotEl) return;
    var gone = !spotTarget.isConnected ||
      (spotTarget.offsetParent === null && getComputedStyle(spotTarget).position !== "fixed");
    if (gone) {
      if (!spotStaleAt) spotStaleAt = Date.now();
      else if (Date.now() - spotStaleAt > 1200) {
        var lb = spotLabel;
        clearSpot();
        post({ t: "gone", page: PAGE, label: lb });
        return;
      }
    } else {
      spotStaleAt = 0;
      var r = spotTarget.getBoundingClientRect();
      spotEl.style.left = (r.left - 7) + "px";
      spotEl.style.top = (r.top - 7) + "px";
      spotEl.style.width = (r.width + 14) + "px";
      spotEl.style.height = (r.height + 14) + "px";
    }
    spotRaf = requestAnimationFrame(positionSpot);
  }
  function clearSpot() {
    if (spotRaf) { cancelAnimationFrame(spotRaf); spotRaf = 0; }
    if (spotClickH && spotTarget) spotTarget.removeEventListener("click", spotClickH, true);
    spotClickH = null;
    spotTarget = null;
    if (spotEl) { spotEl.remove(); spotEl = null; }
  }
  function highlight(q) {
    clearSpot();
    var hit = findByLabel(String(q || ""));
    if (!hit) return { found: false, note: "no visible element matching this label on " + PAGE };
    injectCss();
    spotTarget = hit.el;
    spotStaleAt = 0;
    spotLabel = hit.label;
    spotEl = document.createElement("div");
    spotEl.id = "scpaSpot";
    spotEl.innerHTML = '<span class="scpa-hint"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11.3V4.5a1.5 1.5 0 0 1 3 0v5.8"/><path d="M12 10.3v-1a1.5 1.5 0 0 1 3 0v2"/><path d="M15 11.3v-.5a1.5 1.5 0 0 1 3 0v3.2a6 6 0 0 1-6 6h-1.6a6 6 0 0 1-4.7-2.3l-2.5-3.1a1.4 1.4 0 0 1 2-1.9l1.8 1.4V6.9"/></svg></span>';
    document.body.appendChild(spotEl);
    try { hit.el.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) { hit.el.scrollIntoView(); }
    positionSpot();
    spotClickH = function () {
      clearSpot();
      post({ t: "click", page: PAGE, label: hit.label });
    };
    hit.el.addEventListener("click", spotClickH, true);
    return { found: true, label: hit.label, page: PAGE };
  }

  function chatRead() {
    var bubbles = document.querySelectorAll(".sc-bubble");
    if (!bubbles.length) return null;
    var msgs = [];
    for (var i = Math.max(0, bubbles.length - 6); i < bubbles.length; i++) {
      var t = (bubbles[i].innerText || "").replace(/\s+/g, " ").trim().slice(0, 140);
      if (t) msgs.push(t);
    }
    var acts = [];
    var ab = document.querySelectorAll(".sc-action");
    for (var j = 0; j < ab.length && acts.length < 8; j++) {
      if (!isVisible(ab[j])) continue;
      var at = (ab[j].innerText || "").replace(/\s+/g, " ").trim().slice(0, 60);
      if (at) acts.push(at);
    }
    var st = document.querySelector(".sc-progress__label");
    return { step: st ? (st.innerText || "").replace(/\s+/g, " ").trim() : "", last_messages: msgs, quick_buttons: acts };
  }
  var _chatSig = "", _chatT = 0;
  new MutationObserver(function () {
    if (_chatT) return;
    _chatT = setTimeout(function () {
      _chatT = 0;
      var ch = chatRead();
      if (!ch) return;
      var latest = ch.last_messages[ch.last_messages.length - 1] || "";
      var sig = ch.step + "|" + latest + "|" + ch.quick_buttons.join(",");
      if (sig === _chatSig) return;
      _chatSig = sig;
      post({ t: "chatadv", page: PAGE, step: ch.step, latest: latest, buttons: ch.quick_buttons.join(" / ") });
    }, 1000);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ── protocole hub ↔ agent ─────────────────────────────────────────── */
  bc.onmessage = function (e) {
    var msg = e.data || {};
    if (msg.t === "ping") { if (msg.page !== PAGE) hello(); return; }
    if (msg.t === "clearall") { if (msg.page !== PAGE) clearSpot(); return; }
    if (msg.t !== "cmd" || msg.page !== PAGE) return;
    if (window.__scpc && /live|connecting/.test(window.__scpc.state() || "")) return; // notre onglet est le tab d'appel : le hub gère
    var res = { t: "res", id: msg.id, page: PAGE };
    try {
      if (msg.action === "read") {
        var s = scan();
        res.ok = true;
        res.title = document.title.replace(/\s+/g, " ").trim().slice(0, 120);
        res.headings = headings();
        res.content = pageText();
        res.elements = s.labels;
        var ch = chatRead();
        if (ch) res.chat = ch;
      } else if (msg.action === "highlight") {
        res.ok = true;
        res.result = highlight(msg.label);
      } else if (msg.action === "clear") {
        clearSpot();
        res.ok = true;
      } else res.ok = false;
    } catch (err) { res.ok = false; res.error = String(err && err.message); }
    post(res);
  };

  window.addEventListener("focus", function () { post({ t: "focus", page: PAGE }); });
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") post({ t: "focus", page: PAGE });
  });
  window.addEventListener("pagehide", function () { clearSpot(); post({ t: "bye", page: PAGE }); });

  hello();
})();
